export const DENTCO_NOTION_HOST = 'https://dentco.notion.site'
